"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserLocaleData = exports.getUserTimezone = exports.parseDate = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
moment_timezone_1.default.locale('en');
exports.default = moment_timezone_1.default;
function parseDate(dateString, format) {
    if (dateString) {
        var date = (0, moment_timezone_1.default)(dateString, format || moment_timezone_1.default.ISO_8601, true);
        if (date.isValid()) {
            return date.toDate();
        }
    }
    return null;
}
exports.parseDate = parseDate;
function getIntlOptions() {
    if (typeof Intl !== 'undefined' &&
        typeof Intl.DateTimeFormat === 'function') {
        return Intl.DateTimeFormat().resolvedOptions();
    }
    return null;
}
function getUserTimezone() {
    var options = getIntlOptions();
    if (options && options.timeZone) {
        return options.timeZone;
    }
    return process.env.APP_DEFAULT_TIMEZONE || 'America/New_York';
}
exports.getUserTimezone = getUserTimezone;
function getUserLocaleData() {
    var options = getIntlOptions();
    if (options && options.locale) {
        return moment_timezone_1.default.localeData(options.locale);
    }
    return moment_timezone_1.default.localeData();
}
exports.getUserLocaleData = getUserLocaleData;
//# sourceMappingURL=timezone.js.map